export default "__VITE_PUBLIC_ASSET__19552589__"